import { useQuery } from "@apollo/client";
import { useNavigate } from "react-router";
import { SwiperSlide } from "swiper/react";
import { GetObjects } from "../../api/objects";
import { GetPlaces } from "../../api/places";
import Center from "../../components/core/Center/Center";
import Image from "../../components/core/Image/Image";
import Loader from "../../components/core/Loader/Loader";
import SliderComponent from "../../components/core/Slider/Slider";
import { translate } from "../../localization";
import styles from "./Slider.module.scss";

const Slider = () => {
  const i18n = translate();
  const navigate = useNavigate();

  const { data: objects, loading: objectsLoading } = useQuery(GetObjects, {
    variables: {
      where: {
        zustaende: {
          some: {
            id: {
              in: ["cm8mqw6fg0094og7k86hnu2bj"],
            },
          },
        },
      },
      hydrateRelationships: true,
    },
  });

  const { data: places, loading: placesLoading } = useQuery(GetPlaces, {
    variables: {
      where: {
        zustaende: {
          some: {
            id: {
              in: ["cm8mqw6fg0094og7k86hnu2bj"],
            },
          },
        },
      },
      hydrateRelationships: true,
    },
  });

  return (
    <Center className={styles.slider}>
      {!objectsLoading && !placesLoading && (
        <SliderComponent
          items={1}
          navigation
          classNamePrevButton={styles.prev}
          classNameNextButton={styles.next}
        >
          {places?.items?.map((x) => (
            <SwiperSlide
              className={styles.slide}
              key={x.id}
              onClick={() => {
                navigate(`/browse/places/${x.id}`);
              }}
            >
              <Image
                className={styles.image}
                src={x.images?.images?.[0]?.bild?.url ?? ""}
              />
              <div className={styles.text}>
                <div className={styles.field}>
                  <div className={styles.label}>{i18n.home.slider.title}: </div>
                  <div>{x.images?.images?.[0]?.displayName}</div>
                </div>
              </div>
            </SwiperSlide>
          ))}
          {objects?.items?.map((x) => (
            <SwiperSlide
              className={styles.slide}
              key={x.id}
              onClick={() => {
                navigate(`/browse/objects/${x.id}`);
              }}
            >
              <Image
                className={styles.image}
                src={x.imageObjects?.[0]?.images?.[0]?.bild?.url ?? ""}
              />
              <div className={styles.text}>
                <div className={styles.field}>
                  <div className={styles.label}>{i18n.home.slider.title}: </div>
                  <div>{x.imageObjects?.[0]?.images?.[0]?.displayName}</div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </SliderComponent>
      )}
      {(objectsLoading || placesLoading) && <Loader />}
    </Center>
  );
};

export default Slider;
